import { selectors } from 'modules/common';

import { EmailData, EmailToSupplierContact, EmailToSupplierContactPersonData } from './EmailToSupplierForm.types';

export const getContactsPersonalData = (contacts: EmailToSupplierContact[]): EmailToSupplierContactPersonData[] => {
    return contacts
        .filter((contact) => contact.emailAddress)
        .map((contact) => ({
            ...contact,
            id: contact.emailAddress,
            text: selectors.user.getDisplayName(contact.firstName, contact.lastName, contact.emailAddress),
        }));
};

export const getValues = (contactsPersonalData: EmailToSupplierContactPersonData[], values: string[]): EmailData[] => {
    return values.map((value) => {
        const item = contactsPersonalData.find((contact) => contact.emailAddress === value);

        return item || { id: value, text: value };
    });
};
